
<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <p class="modal-title">
        <i class="fas fa-database mr-2"></i>
        <span class="font-weight-bold">Account Details</span>
      </p>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="p-3">
        <div class="form-row">
          <div class="col-7">
            <div class="form-group">
              <label>Custodian</label>
              <input v-model="account.custodian" class="form-control form-control-sm" placeholder="Master"
                :readonly="account.readonly(`master`)" />
              <small class="form-text text-muted">Account Custodian</small>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Number</label>
              <input v-model="account.number" class="form-control form-control-sm" placeholder="Number"
                :readonly="account.readonly(`number`)" />
              <small class="form-text text-muted">Account Number</small>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <label>Name</label>
              <input v-model="account.name" class="form-control form-control-sm" placeholder="Name" />
              <small class="form-text text-muted">Account Name</small>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <label>Household</label>
              <searchable-dropdown
                v-if="account.households && account.households.length"
                :o="account"
                p="household"
                :items="account.households"
                itemText="name"
                itemValue="_id"
                placeholder="Search households..."
                :disabled="account.disabled('household')"
              />
              <small class="form-text text-muted">Account Household</small>
            </div>
          </div>
        </div>
        <div v-if="account._id" class="form-row">
          <div class="col-4">
            <div class="form-group">
              <label for="accountFundedDate">Account Funded Date</label>
              <date-picker v-model="account.fundedDate" format="MMM D, YYYY" style="  width: 100%;" placeholder=""
                :disabled-date="notAfterToday"></date-picker>
              <small class="form-text text-muted">Select account funded date</small>
            </div>
          </div>
          <div class="col-4 offset-4">
            <div class="form-group">
              <label>Internal Rep ID</label>
              <searchable-dropdown
                v-if="account.repcodes"
                :o="account"
                p="repCode"
                :items="account.repcodes"
                itemText="displayLabel"
                itemValue="code"
                placeholder="Search rep codes..."
              />
              <small class="form-text text-muted">Internal Rep ID code</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer pr-3">
      <div class="text-right footer-controls" :class="{ 'is-ready': account.footerReady }">
        <template v-if="!account.isListedUnderCustodian">
          <span title="Removing an account will also remove it from any contract it is associated with" class="mr-2">
            <i class="fas fa-info-circle text-muted"></i>
          </span>
          <remove-button :button="account.remove"></remove-button>
        </template>
        <template v-else-if="account.isMissingOnCustodian">
          <button type="button" class="btn btn-sm btn-warning ml-2" v-on:click="account.click('archive')">
            <span class="button">Archive</span>
          </button>
        </template>
        <button type="button" class="btn btn-sm btn-primary ml-2" :disabled="account.disabled(`save`)"
          v-on:click="account.click(`save`)">
          <span class="button">Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
